
	import {Component, Vue, Watch} from 'vue-property-decorator';
	import { AxiosStatic } from 'axios';
	import IResource from "@/IResource";
	import { Device } from '@/mixins/Device';
	import { mixins } from 'vue-class-component';

	@Component({
		components: {},
	})
	export default class StepData extends mixins(Device) {
		public $http!: AxiosStatic;

		public isLoading: boolean = false;
		public validationActive: boolean = false;
		public name: string = this.$store.state.name;
		public email: string = this.$store.state.email;
		public errors = {
			name: false,
			email: false,
			save: false,
			customvalues: {} as { [id: number]: boolean }
		};

		public customvalues: { [id: number]: any } = {};

		get mode() {
			return this.$store.state.mode;
		}

		get resource(): IResource {
			return this.$store.state.resource;
		}

		public mounted() {
			this.$gtag.pageview( {page_path: '/step-data' });
		}

		public checkForm() {
			let isValid: boolean = true;
			this.errors.name = false;
			this.errors.email = false;
			this.errors.customvalues = {};
			if (!this.name) {
				this.errors.name = true;
				isValid = false;
			}
			if (!this.checkEmail()) {
				this.errors.email = true;
				isValid = false;
			}

			// validate custom fields
			if (this.resource.customfields) {
				this.resource.customfields.forEach((field: any) => {
					if (field.required) {
						if (field.type === 'checkbox') {
							if (typeof this.customvalues[field.id] === 'undefined' || !this.customvalues[field.id]) {
								isValid = false;
								this.$set(this.errors.customvalues, field.id, true);
							}
						} else {
							if (typeof this.customvalues[field.id] === 'undefined' || this.customvalues[field.id].length === 0) {
								isValid = false;
								this.$set(this.errors.customvalues, field.id, true);
							}
						}
					}
				});
			}
			return isValid;
		}

		public checkEmail() {
			let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(this.email.toLowerCase());
		}

		public goToLastPage() {
			if (this.resource.checkin_time_enabled && this.resource.type === 'multiday') {
				this.$store.commit('SET_STEP', 'step1');
			} else {
				this.$store.commit('SET_STEP', 'step2');
			}
		}

		@Watch('name')
		@Watch('email')
		@Watch('customvalues', {deep: true})
		public validateOnInput() {
			if (this.validationActive) {
				this.checkForm();
			}
		}

		public saveReservation() {
			//ToDo: checkData
			let start = new Date(this.$store.state.startdate);
			start.setHours(Math.floor(this.$store.state.fromtime / 60));
			start.setMinutes(this.$store.state.fromtime % 60);
			let end = new Date(this.$store.state.enddate);
			end.setHours(Math.floor(this.$store.state.totime / 60));
			end.setMinutes(this.$store.state.totime % 60);
			let startStr: string = `${start.getFullYear()}-${start.getMonth() + 1}-${start.getDate()} ${start.getHours()}:${start.getMinutes()}`;
			let endStr: string = `${end.getFullYear()}-${end.getMonth() + 1}-${end.getDate()} ${end.getHours()}:${end.getMinutes()}`;
			let data = {
				name: this.$store.state.name,
				email: this.$store.state.email,
				start: startStr,
				end: endStr,
				customvalues: this.customvalues
			};

			let url = '/public/resource/' + this.resource.reservationhash + '/reservation';
			this.isLoading = true;
			this.$http.post(url, data).then(() => {
				this.isLoading = false;
				this.$store.commit('SET_STEP', 'step4');
			}).catch(() => {
				this.isLoading = false;
				this.errors.save = true;
			});
			return true;
		}

		public checkAndSaveData() {
			this.validationActive = true;
			if(this.checkForm()) {
				this.$store.commit('SET_NAME', this.name);
				this.$store.commit('SET_MAIL', this.email);
				this.saveReservation();
			}
		}
	}
